import React from 'react'
import { Link } from 'react-router'
import { USER_VERIFICATION_STATUSES } from '@Const/user-statuses'
import Navigation from '@App/navigation'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import './index.scss'
import { UserInfoType } from '@Entities/schemas/user/user-info-schema'
import { UserInfo } from '@Entities/user/user'

interface ProfileAccountInfoSectionProps {
    userInfo: Partial<UserInfoType> | Partial<UserInfo> | undefined
    startEditInfo?(): void
    getVerified?(): void
}

const ProfileAccountInfoSection = (props: ProfileAccountInfoSectionProps) => {
    const { userInfo, getVerified } = props
    const isInternal = userInfo && userInfo.isInternal

    return (
        <section className="account-info-section">
            <h5>Account Info</h5>
            <div className="fields-row-container nowrap">
                <div className="field-block">
                    <p className="small title">Password</p>
                    <p className="value">•••••••••••••••</p>
                </div>
                <div className="field-block bottom-align">
                    <Link to={Navigation.profile.changePassword()} className="link">
                        Change Password
                    </Link>
                </div>
            </div>
            <div className="fields-row-container nowrap verified-row">
                <div className="field-block verified-block">
                    <p>Verification status: &nbsp;</p>
                    <strong>{userInfo?.verificationStatus}</strong>
                </div>
                <div className="field-block bottom-align">
                    {!isInternal &&
                        (userInfo?.verificationStatus === USER_VERIFICATION_STATUSES.PENDING ||
                            userInfo?.verificationStatus === USER_VERIFICATION_STATUSES.INVITE_SENT) && (
                            <span className="line">
                                <>
                                    <p onClick={getVerified} className="link blue-text">
                                        Get Verified
                                    </p>
                                    <CustomToolTip
                                        type="?"
                                        info={
                                            'Adding members requires a higher level of account access that is subject to a verification step. Please visit' +
                                            ' your Account Info on your Profile page and click on Get Verified.'
                                        }
                                    />
                                </>
                            </span>
                        )}
                </div>
            </div>
        </section>
    )
}

export default ProfileAccountInfoSection
